export default __webpack_public_path__ + "static/Abundance-27ac44ae9f7b385f9fd18f702b594183.png";